// Packages
import { createApp, defineAsyncComponent } from 'vue';
import VueTippy from 'vue-tippy';
import 'tippy.js/dist/tippy.css'; // optional for styling
import 'tippy.js/themes/light.css';

// Vue components
import SearchList from '@vue-components/SearchList.vue';

export default function init(): void {
  const el = document.querySelector<HTMLElement>('#search-index')!;

  // Create Vue instance for people search
  const vueInstance = createApp({
    name: 'SearchIndex',
    compilerOptions: {
      delimiters: ['${', '}'],
    },
    components: {
      SearchList,
      ArticleCard: defineAsyncComponent(() => import('@vue-components/cards/ArticleCard.vue')),
    },
  });

  vueInstance.use(
    VueTippy,
    // optional
    {
      defaultProps: {
        theme: 'ick',
        placement: 'bottom',
        offset: [0, 20], // Default is [0, 10]
      },
    },
  );

  // Mount the app
  vueInstance.mount(el);
}
